"use strict";
import fetch from "@elements/fetch";
import 'url-search-params-polyfill'; // Edge Polyfill
import formDataEntries from 'form-data-entries';
import {showNotification} from '@elements/alert-notification';

export function initInScope ($scope) {
    $scope.find('.js-optional-required__checkbox').on('change', function (e) {
        let $checkbox = $(this),
            checkboxValue = $checkbox.data('defaultvalue'),
            $group = $checkbox.closest('.js-optional-required'),
            $input = $group.find('.js-optional-required__input');


        if($checkbox.is(':checked')){
            $input.attr('required', false);
            $input.val(checkboxValue);

            if($input.hasClass('is-invalid')){
                $input.parsley().validate();
            }
        }else{
            $input.attr('required', true);

            if(!$input.is('select')){
                $input.val('');
            }
        }


        let url = $checkbox.data('fetch-url');

        let request = fetch(url, {
            method: 'POST'
        });

        request.then(response => response.json())
            .then(result => {
                if (result.success) {
                }else{
                    showNotification({
                        type: 'danger',
                        content: result.errorText,
                        closable: true
                    });
                }
                // $resultLoading.attr('hidden', 'hidden');
            }).catch(e => {
            // $resultLoading.attr('hidden', 'hidden');
            console.warn(e);
        });

    });

}